<template lang="html">
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body fluid="xl">
        <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
          <b-row>
            <b-col>
              <b-form-group label="Select Date"  label-for="paymentDate">
                <b-form-datepicker
                  id="paymentDate"
                  name="paymentDate"
                  :state="validateState('paymentDate')"
                  v-model.trim="$v.form.paymentDate.$model"
                  placeholder="DD/MM/YYYY"
                  today-button
                  reset-button
                  close-button
                  value-as-date
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-btn type="submit" variant="success" :disabled="$v.form.$invalid">Submit</b-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
  </b-card>
  <b-card v-if="reportData!=null && Object.keys(reportData).length > 0">
      <ag-grid-vue   class="ag-theme-balham"
        :gridOptions="gridOptions"
        id="PaymentReceivedByDateGrid"
        :rowData="reportData"
        :pagination="true"
        :paginationPageSize="50"
        :suppressNoRowsOverlay="true"
        :pinnedBottomRowData="pinnedBottomRowData"
        :frameworkComponents="frameworkComponents"
        :floatingFilter="true"
        :getRowStyle="getRowStyle"
        :modules="modules"
        @gridReady="gridReady">
      </ag-grid-vue>
  </b-card>
  </div>
</template>


<script>
  import Vue from 'vue'
  import {AgGridVue} from "ag-grid-vue";
  import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model'
  import CustomPinnedRowRenderer from './components/customPinnedRowRendererVue.js';
  import VueLodash from 'vue-lodash'
  import map from 'lodash/map'
  import {
    mapState,
    mapActions
  } from 'vuex'
  import moment from 'moment'
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";

  const formShape = {
    paymentDate: new Date()
  }

  export default {
    name: 'PaymentReceivedByDate',
    mixins: [validationMixin],
    components: {
      AgGridVue
    },
    data: function() {
      return {
        form: Object.assign({}, formShape),
        reportData: null,
        pinnedBottomRowData: null,
        getRowStyle: null,
        gridApi: null,
        modules: [ClientSideRowModelModule],
        frameworkComponents: {customPinnedRowRenderer: CustomPinnedRowRenderer},
        gridOptions: {
          context: {
            componentParent: this
          },
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agNumberColumnFilter',

          },
          columnDefs: [
            {headerName: 'Satsangi Profile', field: 'profilename', filter: 'agTextColumnFilter', minWidth: 200},
            {headerName: 'Address', field: 'houseno', filter: 'agTextColumnFilter', minWidth: 200},
            {headerName: 'Bhaint Type', field: 'chargename',filter: 'agTextColumnFilter',minWidth: 200},
            {headerName: 'Reading Date', field: 'readingdate', filter: 'agDateColumnFilter', minWidth: 200, valueFormatter: this.dateFormatter, },
            {headerName: 'Amount Applied', field: 'amount',minWidth: 200, valueFormatter: this.currencyFormatter,
                  pinnedRowCellRenderer: 'customPinnedRowRenderer',pinnedRowCellRendererParams: { style: { 'font-style': 'italic', 'font-size': 'large', 'color': 'firebrick' } }},

          ]
       }
      }
    },
    computed: {
      isValid() {
        this.$v.$touch();
        return !this.$v.form.$anyError
      },

    },
    validations: {
      form: {
        paymentDate: {
          required
        }
      }
    },
    methods:{
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      },

      dateFormatter(params) {
        if(params.value == undefined){
          return;
        }
        return moment(params.value).format('MMMM / YYYY');
      },
      currencyFormatter(params) {
        console.log(params);

        var data = Number(params.value).toFixed(2);
        var formatted = data.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return 'Rs.' + `${formatted}`;


      },
      onSubmit() {
          if(this.isValid){
          this.$nextTick(() => {
            this.$store.dispatch('electrical/getPaymentsReceivedByDate', {paymentDate: this.formatDate(this.form.paymentDate)})
              .then((response) => {
                if(response.data.success == false){
                    this.showErrorMsg({
                      message: response.data.error
                    });
                }
                else{
                  this.reportData = response.data.data;
                  if(Object.keys(this.reportData).length > 0){
                    var amountTotal = this.reportData.map(rec => rec.amount).reduce((acc, amount) => amount + acc);
                    this.pinnedBottomRowData = [{amount: amountTotal}];
                    this.showSuccessMsg({
                      message: 'Records Retrieved successfully.'
                    });


                  //  console.log();
                  //  this.gridOptions.api.setPinnedBottomRowData(rows);
                  }
                  else{
                    this.showSuccessMsg({
                      message: 'No Records Found for given criteria.'
                    });
                  }


                }
              })
              .catch((error) => {
                console.log(error);
                if (error.response.status == 400) {
                  this.showErrorMsg({
                    message: error.response.data.message
                  })
                }
                else if (error.response.status == 422){
                    this.showErrorMsg({
                      message: error.response.data.message
                    });

                }
                else {
                  this.showErrorMsg({message: "Something went wrong. Please contact administrator."})
                }
              })

          })
        }
      },
      gridReady(){
         this.gridOptions.api.sizeColumnsToFit();
         this.gridApi = this.gridOptions.api;
         console.log(this.gridOptions.api);
      },
      onReset() {
        this.form = formShape
        this.$nextTick(() => {
          this.$v.$reset()
        })
      },

    },
    beforeMount() {
      this.getRowStyle = (params) => {
        if (params.node.rowPinned) {
          return { 'font-weight': 'bold' };
        }
      };
      this.frameworkComponents = {
        customPinnedRowRenderer: CustomPinnedRowRenderer,
      };
    },
    mounted() {
      console.log(this.gridOptions);
      this.gridApi = this.gridOptions.api;
    },

  }
</script>

<style lang="css">
.ag-row-hover {
/* putting in !important so it overrides the theme's styling as it hovers the row also */
background-color: #dfdfff !important;
}

.ag-column-hover {
background-color: #dfffdf;
}
</style>
